import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PageHeader } from "@/widgets/page-header"
import DatePicker from "react-datepicker";
import CalendarIcon from "@/shared/assets/images/CalendarBlank.svg"
import * as yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { getMarketingCampaignReport } from "@/shared/api/marketing-campaigns/marketing-campaigns";

interface CreateReportFormValues {
    start_date: Date | undefined,
    end_date: Date | undefined,
}

const initial: CreateReportFormValues = {
    start_date: undefined,
    end_date: undefined,
}

const createCampaignValidationSchema = yup.object().shape({
    start_date: yup.date().required("Укажите дату начала"),
    end_date: yup.date().min(yup.ref('start_date'), "Некорректная дата").required("Укажите дату окончания"),
})

export const MarketingCampaignsReportPage = () => {
    const {
        control,
        watch,
        handleSubmit,
        setValue,
        formState: {
            isSubmitting,
        },
    } = useForm({
        defaultValues: initial,
        resolver: yupResolver(createCampaignValidationSchema)
    })

    const onSubmit = async (data: CreateReportFormValues) => {
        const responseBlob = await getMarketingCampaignReport(data.start_date.toISOString(), data.end_date.toISOString())
        const url = window.URL.createObjectURL(new Blob([responseBlob.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
        const link = document.createElement('a')
        link.href = url

        link.setAttribute(
            'target',
            `_blank`,
        )
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
    }

    return (
        <div className="_page_container">
            <PageHeader title="Маркетинговые кампании" />
            <div className="flexbox flex-1">
                <PageSubtitle title="Отчеты" />
                <div className="p-4 flex-1 bg-white rounded-3xl">
                    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col h-full">
                        <div className="flex flex-[1_1_auto] flex-col gap-2">
                            <h1 className="font-mediumttf text-lg">СОЗДАНИЕ ОТЧЕТА</h1>
                            <div className="flex flex-col gap-4">
                                <div>
                                    <div className="mb-1 font-medium">
                                        Начальная дата
                                    </div>
                                    <Controller
                                        control={control}
                                        name={'start_date'}
                                        render={({ field }) => (
                                            <DatePicker 
                                                selected={field.value}
                                                onChange={(date: Date | null) => setValue('start_date', date)}
                                                wrapperClassName="react-datepicker-form2"
                                                dateFormat={"dd.MM.yyyy"}
                                                showIcon
                                                placeholderText="Выберите начальную дату"
                                                enableTabLoop={false}
                                                popperProps={{
                                                    placement: 'bottom'
                                                }}
                                                
                                                icon={(<CalendarIcon width={24} height={24}/>)}
                                            />
                                        )}
                                    />
                                </div>
                                <div>
                                    <div className="mb-1 font-medium">
                                        Конечная дата
                                    </div>
                                    <Controller
                                        control={control}
                                        name={'end_date'}
                                        render={({ field }) => (
                                            <DatePicker 
                                                selected={field.value}
                                                minDate={watch('start_date')}
                                                onChange={(date: Date | null) => setValue('end_date', date)}
                                                wrapperClassName="react-datepicker-form2"
                                                dateFormat={"dd.MM.yyyy"}
                                                showIcon
                                                placeholderText="Выберите начальную дату"
                                                enableTabLoop={false}
                                                popperProps={{
                                                    placement: 'bottom'
                                                }}
                                                
                                                icon={(<CalendarIcon width={24} height={24}/>)}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-[0_0_auto] flex-col gap-2">
                            <button
                                type="submit" 
                                className="w-[400px] py-4 text-lg rounded-xl font-bold text-white bg-color-primary hover:bg-color-primary/70 transition"
                                disabled={isSubmitting}
                            >
                                Создать отчет
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}